import { toast } from "react-toastify";

export const getErrorMessage = (error: any): string => (error.response?.data?.errors[0].length > 0 ? error.response?.data?.errors[0] : "");

export const classNames = (classes: Record<string, boolean | undefined | null | 0>): string => {
  return Object.entries(classes)
    .filter(([_, condition]) => Boolean(condition))
    .map(([className]) => className)
    .join(" ");
};

const PREFIX = "preferences-";

export const setPreference = (key: string, value: any) => localStorage.setItem(`${PREFIX}${key}`, JSON.stringify({ value }));

export const getPreference = (key: string, defaultValue: any = null) => {
  let item: any = localStorage.getItem(`${PREFIX}${key}`);

  if (!item) return defaultValue;

  try {
    item = JSON.parse(item);
    return item.value;
  } catch (err) {
    return null;
    throw err;
  }
};

export const removeGenerationParam = (urlPath: string) => {
  if (!urlPath) return "";

  if (urlPath.indexOf("generation") === -1) return urlPath;

  return urlPath.replace("generation", "noversion");
};

export const validateEmail = (email: string) => {
  return email.match(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
};

export const copyToClipboard = async (txt: string) => {
  try {
    await navigator.clipboard.writeText(txt);
  } catch (err) {
    toast.error("Failed to copy");
    throw err;
  }
};

export const handleCopyToClipboard = (content: string, message: string) => copyToClipboard(content).then(() => toast.success(message));

export const getBrowserLanguage = () => {
  const locale = localStorage.getItem("locale");
  if (locale && (locale === "en-GB" || locale === "nl-NL" || locale === "de-DE" || locale === "fr-FR")) {
    return locale;
  }
  const queryLanguage = new URLSearchParams(window.location.search).get("lang");
  if (queryLanguage) return queryLanguage;

  let language = "";
  if (navigator.language.includes("en")) {
    language = "en-GB";
  } else if (navigator.language.includes("nl")) {
    language = "nl-NL";
  } else if (navigator.language.includes("de")) {
    language = "de-DE";
  } else if (navigator.language.includes("fr")) {
    language = "fr-FR";
  } else {
    language = "en-GB";
  }
  return language;
};

export const languages = [
  {
    text: "Dutch",
    value: "nl-NL",
    key: "nl"
  },
  {
    text: "French",
    value: "fr-FR",
    key: "fr"
  },
  {
    text: "English",
    value: "en-GB",
    key: "en"
  },
  {
    text: "German",
    value: "de-DE",
    key: "de"
  }
];

export const getPreviewUrl = (url: string): string => {
  let modifiedUrl = url.replace("://www.", "://storage.");
  modifiedUrl = modifiedUrl.replace("/download/storage/v1/b/", "/");
  modifiedUrl = modifiedUrl.replace("/o/", "/");

  return modifiedUrl;
};

// eslint-disable-next-line no-var
var timer: NodeJS.Timeout | null = null;

export const debounce = <F extends (...args: any[]) => void>(func: F, delay: number) => {
  return (...args: Parameters<F>) => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      func(...args);
      timer = null;
    }, delay);
  };
};
